const ParticipantSessionFooter = () => {
  return (
    <div className="px-4">
      <div className="border-t-[1px] border-divider mb-4"></div>
      <div className="text-grey text-sm overflow-scroll h-[62px] scrollbar-hide">
        <p>For the best experience:</p>
        <ol>
          <li>1 . Keep "Mirror My Video" off in Video Settings</li>
          <li>2 . Do not "Stop Video"</li>
        </ol>
      </div>
    </div>
  )
}

export default ParticipantSessionFooter
